export default __webpack_public_path__ + "static/media/pandas.04d44888.svg";